import { ContainerProps, components } from 'react-select';
import { isNumber } from 'utils/tsHelpers';
import { TipAlign } from 'ui/tooltip';
import { HTMLAttributes } from 'react';
import { StyledToggleTip, OptionLimitContainer } from './Select.styles';
import { BaseOption } from './types';

export const SelectContainer = (props: ContainerProps<BaseOption>) => {
  const value = props.getValue();
  // @ts-ignore
  const { optionLimit } = props.selectProps;
  const tooltipContent = `${value.length}/${optionLimit}`;

  return isNumber(optionLimit) ? (
    <OptionLimitContainer data-test="select-option-limit-container">
      <StyledToggleTip
        tooltipContent={tooltipContent}
        isEnabled={isNumber(optionLimit) && !props.isDisabled}
        align={TipAlign.End}
      >
        <components.SelectContainer {...props} />
      </StyledToggleTip>
    </OptionLimitContainer>
  ) : (
    <components.SelectContainer
      {...props}
      innerProps={
        { ...props?.innerProps, 'data-test': 'select-container' } as HTMLAttributes<HTMLDivElement>
      }
    />
  );
};
